<style scoped>

</style>
<template>
  <div>
    <div class="line text-center">
      <h2>工资发放记录</h2>
    </div>
    <div class="list-container">
      <Table
        ref="table"
        border
        :columns="informal_wage_topic_columns"
        :data="valid_topics"
        :no-data-text="topic_empty_tip"
        size="small"
      />
      <div
        v-show="isTopicLoading"
        class="back-drop text-center"
      >
        <div class="loading-icon">
          <Spin size="large" />
        </div>
      </div>
    </div>
  </div>
</template>
<script :route="{path: '/team/team_informal_wage_topic',noChkout: true}">
  import Util from '../../libs/util';
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: {
      path: '/team/team_informal_wage_topic',
      noChkout: true
    },
    /* router_info_end */

    data() {
      return {
        informal_wage_topic_columns: [
          {
            title: '月份',
            key: 'wage_month',
            fixed: 'left',
            align: 'center',
            width: 80
          },
          {
            title: '名称',
            key: 'name',
          },
          {
            title: '开始时间',
            key: 'wage_start',
            align: 'center',
            render: (h, params) => {
              return h('span', `${params.row.wage_start}(含)`)
            }
          },
          {
            title: '结束时间',
            key: 'wage_end',
            align: 'center',
            render: (h, params) => {
              return h('span', `${params.row.wage_end}(含)`)
            }
          },
          {
            title: '可发放团队',
            key: 'team_ids',
            align: 'center',
            render: (h, params) => {
              const team_ids = params.row.team_ids;
              if (!team_ids) {
                return h('span', '全部');
              } else {
                let team_names = '';
                team_ids.split(',').forEach((id_str) => {
                  const team_id = parseInt(id_str);
                  team_names += this.teams_hash[team_id]&&`[${this.teams_hash[team_id].name}]`||'';
                });
                return h('span', team_names);
              }
            }
          },
          {
            title: '操作',
            key: 'action',
            fixed: 'right',
            align: 'center',
            width: 80,
            render: (h, params) => {
              if (params.row.status == 5) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'text',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.goToTeamWageTopic(params.row);
                      }
                    }
                  }, '查看')
                ]);
              } else {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    on: {
                      click: () => {
                        this.goToTeamWageTopic(params.row);
                      }
                    }
                  }, '去审核')
                ]);
              }
            }
          }
        ],
        informal_wage_topics: [],
        // 获取列表时
        topic_empty_tip: '获取数据中...',
        isTopicLoading: false,

      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters({
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
      }),
      valid_topics() {
        const topics = [];
        this.informal_wage_topics.forEach((topic) => {
          const team_ids = topic.team_ids || '';
          const ids = team_ids.split(',').map((id) => {return id * 1});
          if (!team_ids || ids.indexOf(this.cur_customer.team_id) > -1) {
            topics.push(topic);
          }
        });
        return topics;
      }
    },
    created() {
      this.getInformalWageTopics();
    },
    methods: {
      getInformalWageTopics() {
        if (!this.isTopicLoading) {
          this.isTopicLoading = true;
          this.topic_empty_tip = '获取数据中...';
          Util.ajax.get(Util.api.informal_wage_topics_path, {

          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.isTopicLoading = false;
            if (res.code === 1) {
              const data = res.data;
              data.forEach((topic) => {
                this.informal_wage_topics.push(topic);
              });
              if (data.length === 0) {
                this.topic_empty_tip = '暂无数据!';
              }
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.isTopicLoading = false;
            this.topic_empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      goToTeamWageTopic(topic) {
        this.$router.push('/team/team_informal_wage_topic_detail/' + topic.id);
      }
    }
  }
</script>
